module.exports = __webpack_public_path__ + "img/UpChat-B.8837daa9.svg";